define('score_bootstrap/Models/Search/SuggestionSection',["jquery", "./SimpleSearchClient"], function ($, SimpleSearchClient) {
    "use strict";

    function SuggestionSection(scope, language, indexName, searchApiUrl, flags) {
        Object.defineProperty(this, '$scope', { value: $(scope), enumerable: !0, configurable: !0, writable: !0 });
        this.setup(language, indexName, searchApiUrl, flags);
    }

    SuggestionSection.prototype.setup = function setup(language, indexName, searchApiUrl, flags) {
        Object.defineProperty(this, 'tileName', { value: this.getTileName(), enumerable: !0, configurable: !0, writable: !0 });
        Object.defineProperty(this, 'searchClient', { value: this.getSearchClient(searchApiUrl, language, indexName, flags), enumerable: !0, configurable: !0, writable: !0 });
        Object.defineProperty(this, 'typeaheadOptions', { value: this.getTypeaheadOptions(), enumerable: !0, configurable: !0, writable: !0 });
    }

    SuggestionSection.prototype.getSuggestions = function (query, ignore /*syncResult*/, asyncResult) {
        this.doSearch(query)
            .done(asyncResult);
    }

    SuggestionSection.prototype.getHeader = function getHeader() {
        var headerText = this.$scope.attr('data-header');
        return headerText ? '<div class="score-typeahead-header">' + headerText + '</div>' : '';
    }

    SuggestionSection.prototype.getPagerSize = function getPagerSize() {
        return (this.$scope.attr('data-count')|0) || 5 /* default value */;
    }

    SuggestionSection.prototype.getTileName = function getTileName() {
        return this.$scope.attr('data-tile-name');
    }

    SuggestionSection.prototype.getSearchClient = function getSearchClient(searchApiUrl, language, indexName, flags) {
        var searchClient = new SimpleSearchClient(searchApiUrl, this.getPagerSize(), language, this.$scope.attr("data-root"),
                                                  indexName, this.$scope.attr("data-templates").split("|"), 0, 0, this.tileName, "SuggestionSection");

        if (typeof (flags) === "object") {
            searchClient.searchRequest.flags = flags;
        }

        return searchClient;
    }

    SuggestionSection.prototype.getTypeaheadOptions = function getTypeaheadOptions() {
        return {
            name: this.$scope.attr("data-id"),
            source: this.getSuggestions.bind(this),
            async: true,
            Key: "Title",
            limit: this.getPagerSize(),
            templates: {
                header: this.getHeader(),
                suggestion: this.buildTile.bind(this),
                footer: this.$scope.html()
            },
            display: function(item) {
                return item.Title;
            }
        };
    }


    SuggestionSection.prototype.buildTile = function buildTile(data) {
        var tileHtml = '';
        if (data && 'Tiles' in data && data.Tiles instanceof Array) {
            // find the tile which we want to show on the suggestion section
            // we aren't using find method because of beloved IE support :) (just kidding), but we don't see a reason to introduce a dependency with "find" polyfill. 
            for (var i = 0; i < data.Tiles.length; i++) {
                var tileEn = data.Tiles[i];
                if (tileEn.Name === this.tileName) {
                    tileHtml = tileEn.Html;
                    // since we already found the tile, lets stop our loop
                    break;
                }
            }
        }

        // short form
        //var tile = data.Tiles.find(function (x) { return x.Name === tileName; }).Html;
        return '<div class="score-typeahead-content">' + tileHtml + '</div>';
    }


    SuggestionSection.prototype.doSearch = function doSearch(query) {
        this.searchClient.searchRequest.query = query;
        return this.searchClient.search().then(function (response) {
            return (response.SearchResults || []);
        });
    };

    return SuggestionSection;
});
